import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { GsmCard } from 'z3k-settings/climatic/notifications/ui/gsm-card';
import { EmailCard } from 'z3k-settings/climatic/notifications/ui/email-card';
export function ClimaticNotifications() {
    return (_jsxs(Box, { display: "flex", flexDirection: "column", rowGap: 2, px: 2, children: [_jsx(GsmCard, {}), _jsx(EmailCard, {})] }));
}
ClimaticNotifications.isWarning = () => false;
ClimaticNotifications.isError = (validation_result) => {
    return false;
};
ClimaticNotifications.isShown = (is_service_view, config, spec, is_staff, is_climatic) => {
    return is_service_view && is_climatic;
};
